var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000088855313069222395470000001121463647142642833_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.116,
    height: 31.525,
    viewBox: "0 0 27.116 31.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social_Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M49.357,261.161a9.963,9.963,0,0,0,5.412-1.545,3.05,3.05,0,0,1,3.7.308,13.542,13.542,0,0,1,4.446,10.061v1.644a3.074,3.074,0,0,1-3.079,3.072H38.878a3.074,3.074,0,0,1-3.079-3.072v-1.644a13.5,13.5,0,0,1,4.439-10.055,3.05,3.05,0,0,1,3.7-.308A10.033,10.033,0,0,0,49.357,261.161Z",
    transform: "translate(-35.799 -243.176)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 7.623,
    cy: 7.623,
    r: 7.623,
    transform: "translate(5.936)",
    fill: "#df9426"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInputIcon);
export default __webpack_public_path__ + "static/media/user_input_icon.1870d51cdab887f9b0c0fff0f4145df9.svg";
export { ForwardRef as ReactComponent };